/* The label a product-card field goes by, for the review of supplier edits
   (spec 20260915 §1.2). Since 2026-09-15 every copied field is compared, keyed
   by the model's column name (`origin_country_id`, not `origin_country`), so
   one map serves the Products row strip and the «Обновления от поставщиков»
   tab. The keys are the card's own labels — nothing new to translate. */

const LABEL_KEYS: Record<string, string> = {
  name: "pf.f.title",
  ean: "pf.f.barcode",
  description: "pd.fields.description",
  unit: "pf.f.unit",
  packaging_qty: "supdir.field.packaging_qty",
  min_order_qty: "pd.minOrderLabel",
  pallet_qty: "pl.col.pallet",
  net_weight_kg: "pf.f.netWeight",
  gross_weight_kg: "pf.f.grossWeight",
  volume_unit: "pf.f.volumeUnit",
  volume_value: "pf.f.volume",
  shelf_life_days: "pf.f.shelfLifeDays",
  storage_conditions: "pf.f.storageConditions",
  manufacturer: "pf.f.manufacturer",
  origin_country_id: "pf.f.originCountry",
  customs_code: "pf.f.customsCode",
  has_export: "pf.f.hasExport",
  incoterms: "pf.f.incoterms",
  brand: "pf.f.brand",
  brand_ownership: "pf.f.brandOwnership",
  composition: "pf.f.composition",
  energy_kcal: "pf.f.kcal",
  energy_kj: "pf.f.kj",
  fat_g: "pf.f.fat",
  saturated_fat_g: "pf.f.saturatedFat",
  carbs_g: "pf.f.carbs",
  sugars_g: "pf.f.sugars",
  protein_g: "pf.f.protein",
  salt_g: "pf.f.salt",
  egais_code: "pf.f.egais",
  alcohol_pct: "pf.f.alcoholPct",
  acetic_acid_pct: "pf.f.aceticAcidPct",
  is_supplement: "pf.f.isSupplement",
  characteristic_sets: "pf.tab.characteristics",
  bicarbonates: "pf.f.bicarbonates",
  sulfates: "pf.f.sulfates",
  chlorides: "pf.f.chlorides",
  calcium: "pf.f.calcium",
  magnesium: "pf.f.magnesium",
  sodium: "pf.f.sodium",
  potassium: "pf.f.potassium",
  vitamin_c_mg: "pf.f.vitaminC",
  vitamin_d: "pf.f.vitaminD",
  min_remaining_shelf_life_pct: "pf.f.minRemainingShelfLife",
  storage_temp_regime: "pf.f.tempRegime",
  humidity_max_pct: "pf.f.humidityMax",
  after_opening_conditions: "pf.f.afterOpeningConditions",
  after_opening_hours: "pf.f.afterOpeningHours",
  needs_temp_control: "pf.f.needsTempControl",
  packaging_languages: "pf.f.languages",
  has_deposit: "pf.f.deposit",
  length_cm: "pf.f.length",
  width_cm: "pf.f.width",
  height_cm: "pf.f.height",
  display_box_length_cm: "pf.f.length",
  display_box_width_cm: "pf.f.width",
  display_box_height_cm: "pf.f.height",
  pcs_per_display_box: "pf.f.pcsPerDb",
  display_boxes_per_box: "pf.f.dbPerBox",
  box_length_cm: "pf.f.length",
  box_width_cm: "pf.f.width",
  box_height_cm: "pf.f.height",
  pcs_per_box: "pf.f.pcsPerBox",
  boxes_per_layer: "pf.f.boxesPerLayer",
  pallet_type_id: "pf.f.palletType",
  pallet_allowed_height_m: "pf.f.palletAllowedHeight",
  pallet_weight_kg: "pf.f.palletWeight",
  layers_per_pallet: "pf.f.layersPerPallet",
  cargo_nature: "pf.f.cargoNature",
  allergens: "pf.tab.allergens",
  standards: "pf.tab.standards",
  label_icons: "pf.tab.icons",
  images: "pf.tab.photo",
};

/* Dimensions of the box levels read «Дисплей-коробка · Длина», as in the
   Products column picker. */
const PREFIX_KEYS: Record<string, string> = {
  length_cm: "pf.sub.unit",
  width_cm: "pf.sub.unit",
  height_cm: "pf.sub.unit",
  display_box_length_cm: "pf.sub.displayBox",
  display_box_width_cm: "pf.sub.displayBox",
  display_box_height_cm: "pf.sub.displayBox",
  box_length_cm: "pf.sub.transportBox",
  box_width_cm: "pf.sub.transportBox",
  box_height_cm: "pf.sub.transportBox",
};

export function productFieldLabel(field: string, t: (key: string) => string): string {
  const key = LABEL_KEYS[field];
  if (!key) return field;
  const prefix = PREFIX_KEYS[field];
  return prefix ? `${t(prefix)} · ${t(key)}` : t(key);
}
